import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson48: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[6.25rem] box-border gap-[6.88rem] text-justify text-[1.56rem] text-white font-dm-sans">
     <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset"/>
      <div className="self-stretch flex flex-row items-center justify-between text-left text-darkgray font-nunito">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson47"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">{`Anti-Inflammatory Diet `}</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson49"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[4.63rem] max-w-[102.63rem] text-[1.88rem]">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem] text-gainsboro-100">
          <p className="m-0 text-[1.88rem] text-white">
            <b>
              Anti-Inflammatory Diet 101: How to Reduce Inflammation Naturally
            </b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            You may be able to reduce and prevent inflammation by choosing
            certain foods and drinks while avoiding others. Anti-inflammatory
            foods can include fruits, vegetables, and fatty fish.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Inflammation is a natural process that helps your body heal and
            defend itself from harm.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            However, inflammation is harmful if it becomes chronic.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Chronic inflammation may last for weeks, months, or years — and may
            lead to various health problems.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            That said, there are many things you can do to reduce inflammation
            and improve your overall health.
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            This article outlines a detailed plan for an anti-inflammatory diet
            and lifestyle
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>What is Inflammation?</b>
          </p>
          <p className="m-0 text-[1.56rem] text-gainsboro-100">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Inflammation is your body’s way of protecting itself from
                  infection, illness, or injury.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  As part of the inflammatory response, your body increases its
                  production of white blood cells, immune cells, and substances
                  called cytokines that help fight infection.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Classic signs of acute (short-term) inflammation include
                  redness, pain, heat, and swelling.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  On the other hand, chronic (long-term) inflammation often
                  occurs inside your body without any noticeable symptoms. This
                  type of inflammation can drive illnesses like diabetes, heart
                  disease, fatty liver disease, and cancer.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Chronic inflammation can also happen when people are obese or
                  under stress.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  When doctors look for inflammation, they test for a few
                  markers in your blood, including C-reactive protein
                  (CRP), homocysteine, TNF alpha, and IL-6.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0 text-orangered">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>SUMMARY</b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Inflammation is a protective mechanism that allows your body to
                defend itself against infection, illness, or injury. It can also
                occur on a chronic basis, which can lead to various diseases.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>What Causes It?</b>
          </p>
          <p className="m-0 text-[1.56rem] text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Certain lifestyle factors — especially habitual ones — can
                promote inflammation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Consuming high amounts of sugar and high-fructose corn syrup is
                particularly harmful. It can lead to insulin resistance,
                diabetes, and obesity.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Scientists have also hypothesized that consuming a lot
                of refined carbs, such as white bread, may contribute to
                inflammation, insulin resistance, and obesity.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                What’s more, eating processed and packaged foods that contain
                trans fats have been shown to promote inflammation and damage
                the endothelial cells that line your arteries.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The FDA has deemed trans fats no longer “Generally Recognized as
                Safe,” so most foods should no longer have trans fats.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Vegetable oils used in many processed foods are another possible
                culprit. Regular consumption may result in an imbalance
                of omega-6 to omega-3 fatty acids, which some scientists believe
                may promote inflammation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Excessive intake of alcohol and processed meat can also have
                inflammatory effects on your body.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Additionally, an inactive lifestyle that includes a lot of
                sitting is a major non-dietary factor that can promote
                inflammation.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <b>SUMMARY</b>
            </span>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Eating unhealthy foods, drinking alcohol or sugary beverages,
                and getting little physical activity are all associated with
                increased inflammation.
              </span>
            </span>
          </p>
        </div>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
        <p className="m-0">
          <b>The Role of Your Diet</b>
        </p>
        <p className="m-0 text-[1.56rem] text-gainsboro-100">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                If you want to reduce inflammation, eat fewer inflammatory foods
                and more anti-inflammatory foods.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Base your diet on whole, nutrient-dense foods that
                contain antioxidants — and avoid highly processed products with
                lots of added sugar and oils.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Antioxidants work by reducing levels of free radicals. These
                reactive molecules are created as a natural part of your
                metabolism but can lead to inflammation when they’re not held in
                check.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Your anti-inflammatory diet should provide a healthy balance of
                protein, carbs, and fat at each meal. Make sure you also meet
                your body’s needs for vitamins, minerals, fiber, and water.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                One diet considered anti-inflammatory is the Mediterranean diet,
                which has been shown to reduce inflammatory markers, such as CRP
                and IL-6.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                A low carb diet also reduces inflammation, particularly for
                people with obesity or metabolic syndrome.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                In addition, vegetarian diets are linked to reduced
                inflammation.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0 text-orangered">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b>SUMMARY</b>
          </span>
        </p>
        <p className="m-0 text-gainsboro-100">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              Choose a nutrient-dense diet that cuts out processed products and
              boosts your intake of whole, anti-inflammatory, antioxidant-rich
              foods.
            </span>
          </span>
        </p>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
        <p className="m-0 text-[1.88rem]">
          <b>Foods to Avoid</b>
        </p>
        <p className="m-0 text-gainsboro-100">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Some foods are associated with an increased risk of chronic
                inflammation.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>Consider minimizing:</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Sugary beverages: </b>
                <span>Sugar-sweetened drinks and fruit juices</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Refined carbs: </b>
                <span>White bread, white pasta, etc.</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Desserts: </b>
                <span>Cookies, candy, cake, and ice cream</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Processed meat: </b>
                <span>Hot dogs, bologna, sausages, etc.</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <b>&nbsp;</b>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b>Processed snack foods: </b>
                <span>Crackers, chips, and pretzels</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Certain oils:</b>
                <span>
                   Processed seed and vegetable oils like soybean and corn oil
                </span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Alcohol:</b>
                <span> Excessive alcohol consumption</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b>SUMMARY</b>
          </span>
        </p>
        <p className="m-0 text-gainsboro-100">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              Avoid or minimize sugary foods and beverages, processed meat,
              excessive alcohol, and foods high in refined carbs and unhealthy
              fats.
            </span>
          </span>
        </p>
      </div>
      <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
        <p className="m-0 text-[1.88rem]">
          <b>5 of the Most Anti-Inflammatory Foods You Can Eat</b>
        </p>
        <p className="m-0 text-gainsboro-100">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>
                Studies suggest that some foods can help decrease chronic
                inflammation. Watch this video to learn about anti-inflammatory
                foods.
              </span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>Include plenty of these anti-inflammatory foods:</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Vegetables:</b>
                <span>
                   Broccoli, kale, Brussels sprouts, cabbage, cauliflower, etc.
                </span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Fruit: </b>
                <span>
                  Especially deeply colored fruits like blueberries,
                  pomegranates, grapes, and cherries
                </span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">High fat fruits:</b>
                <span> Avocados and olives</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Healthy fats: </b>
                <span>Olive oil and avocado oil</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Fatty fish: </b>
                <span>Salmon, sardines, herring, mackerel, and anchovies</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Nuts: </b>
                <span>Almonds and other nuts</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Peppers:</b>
                <span> Bell peppers and chili peppers</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Chocolate: </b>
                <span>Dark chocolate</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Spices: </b>
                <span>Turmeric, fenugreek, cinnamon, etc.</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Tea: </b>
                <span>Green tea</span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <ul className="m-0 pl-[2.06rem]">
          <li className="mb-[0rem]">
            <span>
              <span>
                <b className="font-dm-sans">Red wine: </b>
                <span>
                  Studies suggest that a compound called resveratrol in wine has
                  anti-inflammatory properties and may benefit health
                </span>
              </span>
            </span>
          </li>
        </ul>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              <span>&nbsp;</span>
            </span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <b>SUMMARY</b>
          </span>
        </p>
        <p className="m-0 text-gainsboro-100">
          <span>
            <span>&nbsp;</span>
          </span>
        </p>
        <p className="m-0">
          <span>
            <span>
              It’s best to consume a variety of nutrient-dense whole foods that
              can reduce inflammation.
            </span>
          </span>
        </p>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson49"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson48;
